import { render, staticRenderFns } from "./ArticlesLayout.vue?vue&type=template&id=576e3136&"
import script from "./ArticlesLayout.vue?vue&type=script&lang=js&"
export * from "./ArticlesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports